import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ContentService {
  public statuses: any = [];
  private userStatuses: {} = {};
  private userMessageStatuses: {} = {};
  public salaries: {} = {};
  public deprecatedSalaryTypes: {} = {};
  public salaryTypes: {} = {};
  public salaryCommissionTypes: {} = {};
  public categories: {} = {};

  private userBgColor: {} = {};
  private statusColor: {} = {};
  private statusColorStyle: {} = {};

  private jobFilters: {} = {};

  private defaultProfilePictureUrl =
    'https://mojobmedia.s3.amazonaws.com:443/cache/fe/a3/fea31bc25b963938c04e6d57175c09df.jpg';

  constructor(private _translate: TranslateService) {
    this.doTranslations();
    this._translate.onLangChange.subscribe(langChangeEvent => {
      this.doTranslations();
    });
  }

  public doTranslations() {
    this._translate
      .get([
        'status_new',
        'status_hired',
        'status_offer',
        'status_interview',
        'status_qualified',
        'status_declined',
        'status_waiting_list',
      ])
      .subscribe(statusStrings => {
        this.statuses = [
          {
            text: statusStrings['status_new'],
            icon: 'fa-question',
            status: 0,
          },
          {
            text: statusStrings['status_hired'],
            icon: 'fa-briefcase',
            status: 1,
          },
          {
            text: statusStrings['status_offer'],
            icon: 'fa-file-text-o',
            status: 2,
          },
          {
            text: statusStrings['status_interview'],
            icon: 'fa-building',
            status: 3,
          },
          {
            text: statusStrings['status_qualified'],
            icon: 'fa-check',
            status: 4,
          },
          {
            text: statusStrings['status_declined'],
            icon: 'fa-times',
            status: 5,
          },
          {
            text: statusStrings['status_waiting_list'],
            icon: 'fa-list-alt',
            status: 6,
          },
        ];
      });

    this._translate
      .get([
        'user_status_new',
        'user_status_hired',
        'user_status_offer',
        'user_status_interview',
        'user_status_qualified',
        'user_status_declined',
        'user_status_waiting_list',
      ])
      .subscribe(userStatusStrings => {
        this.userStatuses = {
          0: {
            text: userStatusStrings['user_status_new'],
            icon: 'fa-question',
            color: 'color-stable-dark',
            status: 0,
          },
          1: {
            text: userStatusStrings['user_status_hired'],
            icon: 'fa-briefcase',
            color: 'color-accept',
            status: 1,
          },
          2: {
            text: userStatusStrings['user_status_offer'],
            icon: 'fa-file-text-o',
            color: 'color-accept',
            status: 2,
          },
          3: {
            text: userStatusStrings['user_status_interview'],
            icon: 'fa-building',
            color: 'color-accept',
            status: 3,
          },
          4: {
            text: userStatusStrings['user_status_qualified'],
            icon: 'fa-check',
            color: 'color-accept',
            status: 4,
          },
          5: {
            text: userStatusStrings['user_status_declined'],
            icon: 'fa-times',
            color: 'color-decline',
            status: 5,
          },
          6: {
            text: userStatusStrings['user_status_waiting_list'],
            icon: 'fa-list-alt',
            color: 'color-stable-dark',
            status: 6,
          },
        };
      });

    this._translate
      .get([
        'user_message_status_new',
        'user_message_status_hired',
        'user_message_status_offer',
        'user_message_status_interview',
        'user_message_status_qualified',
        'user_message_status_declined',
        'user_message_status_waiting_list',
      ])
      .subscribe(userMessageStatusStrings => {
        this.userMessageStatuses = {
          0: {
            text: userMessageStatusStrings['user_message_status_new'],
            icon: 'fa-question',
            color: 'color-stable-dark',
            status: 0,
          },
          1: {
            text: userMessageStatusStrings['user_message_status_hired'],
            icon: 'fa-briefcase',
            color: 'color-accept',
            status: 1,
          },
          2: {
            text: userMessageStatusStrings['user_message_status_offer'],
            icon: 'fa-file-text-o',
            color: 'color-accept',
            status: 2,
          },
          3: {
            text: userMessageStatusStrings['user_message_status_interview'],
            icon: 'fa-building',
            color: 'color-accept',
            status: 3,
          },
          4: {
            text: userMessageStatusStrings['user_message_status_qualified'],
            icon: 'fa-check',
            color: 'color-accept',
            status: 4,
          },
          5: {
            text: userMessageStatusStrings['user_message_status_declined'],
            icon: 'fa-times',
            color: 'color-decline',
            status: 5,
          },
          6: {
            text: userMessageStatusStrings['user_message_status_waiting_list'],
            icon: 'fa-list-alt',
            color: 'color-stable-dark',
            status: 6,
          },
        };
      });

    this._translate
      .get([
        'salary_level_undefined',
        'salary_level_1',
        'salary_level_2',
        'salary_level_3',
        'salary_level_4',
        'salary_level_5',
        'salary_level_6',
      ])
      .subscribe(salaryLevelStrings => {
        this.salaries = {
          0: {
            name: salaryLevelStrings['salary_level_undefined'],
            value: 0,
          },
          1: { name: salaryLevelStrings['salary_level_1'], value: 1 },
          2: { name: salaryLevelStrings['salary_level_2'], value: 2 },
          3: { name: salaryLevelStrings['salary_level_3'], value: 3 },
          4: { name: salaryLevelStrings['salary_level_4'], value: 4 },
          5: { name: salaryLevelStrings['salary_level_5'], value: 5 },
          6: { name: salaryLevelStrings['salary_level_6'], value: 6 },
        };
      });

    this._translate
      .get([
        'salary_type_fixed',
        'salary_type_hourly',
        'salary_type_commission',
        'salary_type_hourly_commission',
        'salary_type_fixed_commission',
      ])
      .subscribe(salaryTypeStrings => {
        this.deprecatedSalaryTypes = {
          0: {
            name: salaryTypeStrings['salary_type_fixed'],
            value: 0,
          },
          1: {
            name: salaryTypeStrings['salary_type_hourly'],
            value: 1,
          },
          2: {
            name: salaryTypeStrings['salary_type_commission'],
            value: 2,
          },
          3: {
            name: salaryTypeStrings['salary_type_hourly_commission'],
            value: 3,
          },
          4: {
            name: salaryTypeStrings['salary_type_fixed_commission'],
            value: 4,
          },
        };
      });

    this._translate
      .get(['salary_type_fixed', 'salary_type_hourly', 'salary_type_none'])
      .subscribe(salaryTypeStrings => {
        this.salaryTypes = {
          0: {
            name: salaryTypeStrings['salary_type_fixed'],
            value: 0,
          },
          1: {
            name: salaryTypeStrings['salary_type_hourly'],
            value: 1,
          },
          2: {
            name: salaryTypeStrings['salary_type_none'],
            value: 2,
          },
        };
      });

    this._translate
      .get(['salary_type_commission', 'salary_type_without_commission'])
      .subscribe(salaryTypeStrings => {
        this.salaryCommissionTypes = {
          0: {
            name: salaryTypeStrings['salary_type_commission'],
            value: 0,
          },
          1: {
            name: salaryTypeStrings['salary_type_without_commission'],
            value: 1,
          },
        };
      });

    this._translate
      .get([
        'job_filter_all',
        'job_filter_published',
        'job_filter_new_applicants',
      ])
      .subscribe(jobFilterStrings => {
        this.jobFilters = {
          0: { name: jobFilterStrings['job_filter_all'], value: 0 },
          1: {
            name: jobFilterStrings['job_filter_published'],
            value: 1,
          },
          2: {
            name: jobFilterStrings['job_filter_new_applicants'],
            value: 2,
          },
        };
      });

    /*
     * ============================================
     *     CATEGORIES - As defined on server
     * ============================================
     */

    this._translate
      .get([
        'job_category_retail',
        'job_category_restaurant',
        'job_category_healthcare',
        'job_category_education',
        'job_category_it_design',
        'job_category_sales_marketing',
        'job_category_cinema',
        'job_category_labour',
        'job_category_model',
        'job_category_internship',
        'job_category_volunteer',
        'job_category_other',
        'job_category_give_a_job',
      ])
      .subscribe(jobCategoryStrings => {
        this.categories = {
          0: {
            name: jobCategoryStrings['job_category_retail'],
            logo: 'store',
            value: 0,
          },
          1: {
            name: jobCategoryStrings['job_category_restaurant'],
            logo: 'hotel',
            value: 1,
          },
          2: {
            name: jobCategoryStrings['job_category_healthcare'],
            logo: 'care',
            value: 2,
          },
          3: {
            name: jobCategoryStrings['job_category_education'],
            logo: 'teaching',
            value: 3,
          },
          4: {
            name: jobCategoryStrings['job_category_it_design'],
            logo: 'it',
            value: 4,
          },
          5: {
            name: jobCategoryStrings['job_category_sales_marketing'],
            logo: 'sales',
            value: 5,
          },
          6: {
            name: jobCategoryStrings['job_category_cinema'],
            logo: 'cinema',
            value: 6,
          },
          7: {
            name: jobCategoryStrings['job_category_labour'],
            logo: 'labour',
            value: 7,
          },
          8: {
            name: jobCategoryStrings['job_category_model'],
            logo: 'model',
            value: 8,
          },
          9: {
            name: jobCategoryStrings['job_category_internship'],
            logo: 'internship',
            value: 9,
          },
          10: {
            name: jobCategoryStrings['job_category_volunteer'],
            logo: 'voulenteer',
            value: 10,
          },
          11: {
            name: jobCategoryStrings['job_category_other'],
            logo: 'other',
            value: 11,
          },
          12: {
            name: jobCategoryStrings['job_category_give_a_job'],
            logo: 'gaj',
            value: 12,
          },
        };
      });

    /*
     * ============================================
     *     PROFILE PIC INITIAL BACKGROUND COLOR
     *
     *     if user has default user-profile picure
     * ============================================
     */

    this.userBgColor = {
      0: { 'background-color': '#1abc9c' },
      1: { 'background-color': '#16a085' },
      2: { 'background-color': '#2ecc71' },
      3: { 'background-color': '#27ae60' },
      4: { 'background-color': '#3498db' },
      5: { 'background-color': '#2980b9' },
      6: { 'background-color': '#9b59b6' },
      7: { 'background-color': '#8e44ad' },
      8: { 'background-color': '#34495e' },
      9: { 'background-color': '#2c3e50' },
      10: { 'background-color': '#f1c40f' },
      11: { 'background-color': '#f39c12' },
      12: { 'background-color': '#e67e22' },
      13: { 'background-color': '#d35400' },
      14: { 'background-color': '#e74c3c' },
      15: { 'background-color': '#c0392b' },
      16: { 'background-color': '#7f8c8d' },
    };

    this.statusColor = {
      0: 'new',
      1: 'hired',
      2: 'offer',
      3: 'interview',
      4: 'qualified',
      5: 'declined',
      6: 'waiting_list',
    };

    this.statusColorStyle = {
      0: { color: '#a3a4a2' },
      1: { color: '#9b59b6' },
      2: { color: '#f1c40f' },
      3: { color: '#8daedf' },
      4: { color: '#67c176' },
      5: { color: '#d56969' },
      6: { color: '#a3a4a2' },
    };
  }

  public getStatus(key) {
    return this.statuses[key].text;
  }

  public getStatusIcon(key) {
    return this.statuses[key].icon;
  }

  public getStatusColor(key) {
    return this.statusColor[key];
  }

  public getStatusColorStyle(key) {
    return this.statusColorStyle[key];
  }

  public getUserStatus(status) {
    return this.statuses[status];
  }

  public getUserMessageStatus(key, type) {
    return this.userMessageStatuses[key][type];
  }

  public getUserStatuses() {
    return this.statuses;
  }

  public getSalary(key) {
    return this.salaries[key];
  }

  public getSalaryType(key) {
    return this.deprecatedSalaryTypes[key];
  }

  public getSalaryStringForAd(
    salary_type: number,
    salary_level?: number,
    salary_amount?: number
  ) {
    if (salary_type == null) {
      return '';
    }

    switch (salary_type) {
      case this.salaries[0].value: // Fixed salary
        if (salary_amount != null) {
          return salary_amount + 'kr/mnd';
        } else {
          return this.salaries[salary_type].name;
        }
      case this.salaries[1].value: // Hourly pay
        if (salary_level != null) {
          return this.salaries[salary_level].name;
        } else {
          return this.salaries[salary_type].name;
        }
      default:
        // Defaults to name of salary type
        try {
          return this.salaries[salary_type].name;
        } catch (e) {
          return 'Ikke oppgitt';
        }
    }
  }

  public calcNumbDays(date) {
    const day = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const now = new Date();
    const due_date = new Date(date);
    return Math.round(Math.abs((now.getTime() - due_date.getTime()) / day));
  }

  /*
   * ============================================
   *     JOB FILTERS
   * ============================================
   */

  public getJobFilters() {
    const filters: {} = {};

    for (const i in this.jobFilters) {
      if (this.jobFilters[i]) {
        const obj = this.jobFilters[i];
        if (obj['name']) {
          filters[i] = this.jobFilters[i];
        }
      }
    }
    return filters;
  }

  /*
   * ============================================
   *     CATEGORIES
   * ============================================
   */

  public getCat(key) {
    return this.categories[key];
  }

  public getCategories() {
    const cat: {} = {};

    for (const i in this.categories) {
      if (this.categories[i]) {
        const obj = this.categories[i];
        if (obj['name']) {
          cat[i] = this.categories[i];
        }
      }
    }
    return cat;
  }

  /*
   * ============================================
   *     PROFILE BACKGROUND COLOR
   *     if default user-profile picture
   * ============================================
   */

  public getUserBgColor(seed: number) {
    const index = seed % Object.keys(this.userBgColor).length;
    return this.userBgColor[index];
  }

  public isDefaultProfilePicture(url: string) {
    if (!url) {
      return true;
    }

    const urlTrim = url.substring(0, url.indexOf('?Signature'));
    const defaultTrim = this.defaultProfilePictureUrl.substring(
      0,
      url.indexOf('?Signature')
    );

    return urlTrim.localeCompare(defaultTrim) === 0;
  }
}
